import Button from "core/buttons/button/Button";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

export default function ActionHandle({
  id,
  navigateView,
  navigateEdit,
  handleDelete,
  canDelete = true,
}) {
  return (
    <div className="display-action-button">
      <Button
        className="btn-hover-color"
        size="small"
        color="blue"
        onClick={() => navigateView(id)}
      >
        <FormattedMessage id={"see"} defaultMessage={"Voir"} />
      </Button>

      <Button
        className="btn-hover-color"
        size="small"
        color="blue"
        onClick={() => navigateEdit(id)}
      >
        <FormattedMessage id={"edit"} defaultMessage={"Editer"} />
      </Button>

      {canDelete && (
        <Button
          className="btn-hover-color"
          size="small"
          color="blue"
          onClick={() => handleDelete(id)}
        >
          <FormattedMessage id={"delete"} defaultMessage={"Supprimer"} />
        </Button>
      )}
    </div>
  );
}

ActionHandle.propTypes = {
  // TableManager passes the row id, which is a number for every referential.
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  navigateView: PropTypes.func,
  navigateEdit: PropTypes.func,
  handleDelete: PropTypes.func,
  canDelete: PropTypes.bool,
};
